import { useLicenseDetails } from "../../contexts/licenseDetails";
import Button from "../Button/Button";
import { useState } from "react";
import TextAreaInput from "../TextAreaInput/TextAreaInput";
import Input from "../Input/Input";
import LicenseService from "../../services/LicensesService";
import {
   getZodFieldErrors,
   licenseBlockSchema,
} from "../../validations/license-subpages.schema";

export function LicenseUnblockPage({ license }) {
   const { setCurrentSubTab } = useLicenseDetails();

   const [reason, setReason] = useState("");
   const [description, setDescription] = useState("");
   const [scheduledFor, setScheduledFor] = useState(
      new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
         .toISOString()
   );
   const [errors, setErrors] = useState({});
   const [isSubmitting, setIsSubmitting] = useState(false);

   async function handleSubmit(event) {
      event.preventDefault();
      const validation = licenseBlockSchema.safeParse({ reason, scheduledFor });
      if (!validation.success) {
         setErrors(getZodFieldErrors(validation.error));
         return;
      }
      setErrors({});
      setIsSubmitting(true);
      try {
         const response = await LicenseService.unblock(license.id, {
            reason,
            scheduledFor,
            observations: description,
         });
         if (response?.status >= 200 && response.status < 300) {
            setCurrentSubTab(null);
         }
      } finally {
         setIsSubmitting(false);
      }
   }

   return (
      <div className="fade-in mt-0.5!">
         <div className="flex flex-row items-center justify-between">
            <h2 className="font-bold! text-[15px]!">Desbloquear licença</h2>
         </div>
         <p className="mt-3! opacity-60 leading-snug!">
            Ao desbloquear a licença, o dispositivo associado voltará a se comunicar com a plataforma. <br />
         </p>
         <form
            className="flex flex-col gap-3 mt-7!"
            onSubmit={handleSubmit}
         >
            <div className="grid grid-cols-2 gap-3">
               <Input
                  name="reason"
                  id="reason"
                  labelText="Motivo *"
                  value={reason}
                  onChange={({ target }) => setReason(target.value)}
                  disabled={isSubmitting}
                  error={errors.reason}
               />
               <Input
                  type={"datetime-local"}
                  name="scheduledFor"
                  id="scheduledFor"
                  labelText="Data do desbloqueio *"
                  value={scheduledFor}
                  onChange={({ target }) => setScheduledFor(target.value)}
                  disabled={isSubmitting}
                  error={errors.scheduledFor}
               />
            </div>
            <TextAreaInput
               name="description"
               id="description"
               labelText="Observações"
               value={description}
               onChange={({ target }) => setDescription(target.value)}
               disabled={isSubmitting}
            />

            <div className="w-full flex flex-row items-center justify-end gap-3! mt-6!">
               <Button
                  className={"button-white"}
                  label={"Cancelar"}
                  onClick={() => setCurrentSubTab(null)}
                  disabled={isSubmitting}
               />
               <Button
                  className={"button-blue"}
                  disabled={isSubmitting}
                  label={"Confirmar desbloqueio"}
                  type={"submit"}
                  isLoading={isSubmitting}
               />
            </div>
         </form>
      </div>
   );
}